module.exports = __webpack_public_path__ + "img/20200801_143716.457e57e1.jpg";